import {
  GET_SCALE_INFOS_IN_PROGRESS,
  GET_SCALE_INFOS_SUCCESS,
  GET_SCALE_INFOS_FAIL,
  POST_SCALE_IN_PROGRESS,
  POST_SCALE_SUCCESS,
  POST_SCALE_FAIL,
  PUT_SCALE_IN_PROGRESS,
  PUT_SCALE_SUCCESS,
  PUT_SCALE_FAIL,
} from "../constants";

const initialState = {
  infos: undefined,
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Scale reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function scale(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_SCALE_INFOS_IN_PROGRESS:
      return {
        ...state,
        infos: undefined,
      };

    case GET_SCALE_INFOS_SUCCESS:
      return {
        ...state,
        infos: payload.infos,
      };

    case GET_SCALE_INFOS_FAIL:
      return {
        ...state,
        infos: null,
      };

    case POST_SCALE_IN_PROGRESS:
    case PUT_SCALE_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case POST_SCALE_SUCCESS:
    case PUT_SCALE_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case POST_SCALE_FAIL:
    case PUT_SCALE_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: payload.violations,
      };

    default:
      return state;
  }
}
